<div class="container">
  <h3 class="container__title">{{'ACCESS_CODE_DIALOG.TITLE' | translate}}</h3>
  <div class="container__contents">
    <p class="message">{{'ACCESS_CODE_DIALOG.ENTER_ACCESS_CODE' | translate}}</p>
    <input type="text" [(ngModel)]="accessCode" (ngModelChange)="error = ''">
    @if (error) {
      <p class="error">{{error | translate}}</p>
    }
    <input type="submit" class="cb-btn" value="{{'ACCESS_CODE_DIALOG.START' | translate}}" (click)="click$.next()" [disabled]="loading">
  </div>
</div>